import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconInterviewStyle0 = gravityIconIndividualCss;

const GravityIconInterview = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: 'c8a07469c46cfee2d5a24164f94c18b18ff95fd3', color: this.color, size: this.size }, h("svg", { key: 'd01975586691998cc63e78696b53849129cb70de', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: '70a6f07629d388c7d774eb5e0f046bd5307cde61', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M2.5 2h12a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5H14a.5.5 0 0 1-.5-.5v-1h-10v6H5a.5.5 0 0 1 .5.5v3a.51.51 0 0 1-.11.28l-.83 1a.33.33 0 0 1-.26.14.31.31 0 0 1-.3-.31V11H2.5a.5.5 0 0 1-.5-.5v-8a.5.5 0 0 1 .5-.5Zm4.98 13.5v-8A.5.5 0 0 1 8 7h11.52a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-.5.5h-1.5v3.29a.3.3 0 0 1-.51.22L13.91 16H8a.5.5 0 0 1-.52-.5Zm9.52-1h1.48l.02-6H9v6h5.29a.47.47 0 0 1 .35.15l1.86 1.85V15a.5.5 0 0 1 .5-.5Z", fill: "currentColor" }))));
    }
};
GravityIconInterview.style = GravityIconInterviewStyle0;

export { GravityIconInterview as gravity_icon_interview };

//# sourceMappingURL=gravity-icon-interview.entry.js.map